export const universalData = {
  howToParticipate: "Students have to register on the website by filling the Registration Form and making the payment. Once registered, the students will be communicated on their email for successfully registering. Furthermore, admit cards for the exam, certificates of participation and detailed exam report will be sent to the student on their email.",

  eligibility: {
    stage1: "Any student of a particular class is eligible to participate in the Olympiad for that class category.",
    stage2: "Top 20% students from each school will be eligible for the Stage II, given that at least 15 students registered from that school and student has achieved at least 50% marks in Stage I",
    specifics: {
      mso: "MSO is open to students of class 7 to 12",
      mcoo: "MCOO is open to students of class 11 and 12",
      mmo: "MMO is open to students of class 7 to 10",
      msso: "MSSO is open to students of class 7 to 10",
      mco: "MCO is open to students of class 7 to 10",
      mho: "MHO is open to students of class 7 to 12",
      meo: "MEO is open to students of class 7 to 12"
    }
  },

  awards: {
    stage1: [
      "I. All participating students receive a \"Certificate of Participation\" and a \"Detailed Exam Report\".",
      "II. Gold Medals for Top 20% students, provided at least 15 students participated from that school and secured at least 50% marks."
    ],
    stage2: [
      "I. All participating students will receive a \"Certificate of Distinction\" and a \"Detailed Exam Report\".",
      "II. Students ranked First, Second and Third will recieve cash prizes of Rs. 11,000/-, Rs. 5,100/- and Rs. 3,100/- respectively along with trophies."
    ],
    schools: [
      "I. All Schools will receive a “Detailed School Report” which will assess all the students of the class.",
      "II. School with the highest participation, as per Stage 1, will receive Highest Participation Trophy along with a cash prize of Rs. 11,000/-."
    ]
  }
};
